<template>
  <div class="content-main__centered">
    <h4 class="mb-3">Let's Play Matchmaker!</h4>
    <p class="mb-2">
      ConveYour treats email addresses and mobile phone numbers as unique
      values.<br />
      First and last names are also very important.
    </p>
    <p class="mb-4">
      Please match as many (as you can) of these important ConveYour fields with
      their respective column in your CSV.
    </p>

    <v-alert
      :value="!uniqueFieldsValid && formValidated"
      transition="fade-transition"
      class="mb-6 pa-2"
      type="error"
      dismissible
    >
      Please match
      <span v-for="(field, idx) in uniqueFields" :key="idx">
        <strong> {{ getFieldLabel(field) }} </strong>
        <template v-if="idx < uniqueFields.length - 1"> or </template>
      </span>
    </v-alert>

    <v-form ref="form">
      <div class="mb-2" v-for="(item, idx) in keyFields" :key="idx">
        <v-autocomplete
          color="primary"
          item-color="primary"
          autocomplete="false"
          placeholder=" "
          default=""
          clearable
          persistent-placeholder
          :items="[getPlaceholderOption(item), ...fieldsOptions]"
          :rules="[validationRules.checkRequired]"
          :label="getFieldLabel(item)"
          v-model="item.value"
          @input="$emit('assign', item)"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import validationRules from '@/lib/validationRules';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ContactsImportMatch',
  props: {
    importedFields: {},
    keyFields: {},
  },
  data() {
    return {
      formValidated: false,
      validationRules,
    };
  },
  computed: {
    fieldsOptions() {
      return Object.keys(this.importedFields).reduce((acc, key) => {
        acc.push({ text: this.importedFields[key], value: key });
        return acc;
      }, []);
    },

    uniqueFields() {
      const nameFields = ['first_name', 'last_name'];
      return this.keyFields.filter((i) => !nameFields.includes(i.name));
    },

    uniqueFieldsValid() {
      return this.uniqueFields.some(({ name }) => {
        const fieldValue = this.getFieldValue(name);
        return fieldValue !== 'empty' && !isEmpty(fieldValue);
      });
    },
  },
  methods: {
    getFieldLabel({ label }) {
      if (label === '$mobile') return 'Mobile';
      return capitalize(label);
    },

    getPlaceholderOption(field) {
      return {
        text: `Do not map "${this.getFieldLabel(field)}" field`,
        value: 'empty',
      };
    },

    getFieldValue(field) {
      const fieldObj = this.keyFields.find((i) => i.name === field);
      return fieldObj.value;
    },

    isValid() {
      this.formValidated = true;
      return this.$refs.form.validate() && this.uniqueFieldsValid;
    },
  },
};
</script>
